const e = {
  name: "RevenueAccelerate",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.90436 1.86797C11.0617 0.710676 12.9433 0.710676 14.1006 1.86797L22.132 9.89942C23.2893 11.0567 23.2893 12.9383 22.132 14.0956L14.1006 22.1271C12.9433 23.2844 11.0617 23.2844 9.90436 22.1271L1.8729 14.0956C0.709107 12.9318 0.701774 11.0584 1.87493 9.8974L9.90436 1.86797ZM12.6864 3.28219C12.3101 2.90594 11.6948 2.90594 11.3186 3.28219L10.0075 4.59324L17.4143 12L10.01 19.4043L11.3186 20.7129C11.6948 21.0891 12.3101 21.0891 12.6864 20.7129L20.7178 12.6814C21.0941 12.3052 21.0941 11.6899 20.7178 11.3136L12.6864 3.28219ZM6.50751 8.09324L10.4143 12L6.50999 15.9043L8.59578 17.9901L14.5859 12L8.5933 6.00745L6.50751 8.09324ZM5.0933 9.50745L3.28261 11.3181C2.90507 11.6909 2.89853 12.2928 3.28712 12.6814L5.09578 14.4901L7.58586 12L5.0933 9.50745Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as RevenueAccelerate
};
